import axios from '../axios'
// 搜索模型
export const search = data => {
    return axios({
        url: '/search',
        method: 'get',
        params: data
    })
}

// 查看科室详情
export const get_category = data => {
    return axios({
        url: '/get_category',
        method: 'get',
        params: data
    })
}

// 查看科室详情
export const get_all_detail = data => {
    return axios({
        url: '/get_all_detail',
        method: 'get',
        params: data
    })
}